import { FC } from "react";
import TableComponent from "../../../../../common/components/table/table.component";
import userTranslationsHelper from "../../../../../languages/user-translations.helper";
import UserStatus from "../../../../../common/types/user-status";
import TableDeleteButtonComponent from "../../../../../common/components/table/button/delete/table-delete-button.component";
import DealerListingItem from "../common/types/dealer-listing-item";
import useDealerListingUserPermissions from "../common/user-permissions/use-dealer-listing-user-permissions";
import DealerListingTableColumn from "../common/types/dealer-listing-table-column";
import dealerListingTableHelper from "./dealer-listing-table.helper";
import DealerListingTableRow from "../common/types/dealer-listing-table-row";
import UserDeleteUserData from "../../../common/delete/common/types/user-delete-user-data";

type DealerListingTableProps = {
  isError: boolean;
  isLoading: boolean;
  listingItems: DealerListingItem[];
  onSelectUserToDelete: (userData: UserDeleteUserData) => void;
};

const DealerListingTableComponent: FC<DealerListingTableProps> = (props) => {
  const userPermissions = useDealerListingUserPermissions();

  const columns: DealerListingTableColumn[] =
    dealerListingTableHelper.getColumns();

  const createTableRow = (
    listingItem: DealerListingItem
  ): DealerListingTableRow => {
    const translations =
      userTranslationsHelper.getDealerListingTranslations().table;

    const activityStatus = dealerListingTableHelper.getStatusText(
      listingItem.status
    );

    const isDeleted = listingItem.status === UserStatus.DELETED;

    const isDeleteButtonVisible =
      !isDeleted && userPermissions.hasAccessToDeleteUser;

    return {
      id: listingItem.uuid,
      idForTesting: listingItem.uuid,
      value: {
        firstName: (
          <div title={listingItem.firstName}>{listingItem.firstName}</div>
        ),
        lastName: (
          <div title={listingItem.lastName}>{listingItem.lastName}</div>
        ),
        userName: (
          <div title={listingItem.userName}>{listingItem.userName}</div>
        ),
        emailAddress: (
          <div title={listingItem.emailAddress}>{listingItem.emailAddress}</div>
        ),
        phoneNumbers: (
          <div>
            {listingItem.phoneNumbers.map((phoneNumber, index) => (
              <div key={index} title={phoneNumber}>
                {phoneNumber}
              </div>
            ))}
          </div>
        ),
        taxiCorporation: (
          <div title={listingItem.taxiCorporationName}>
            {listingItem.taxiCorporationName}
          </div>
        ),
        status: <div title={activityStatus}>{activityStatus}</div>,
        actions: (
          <div className="d-flex" onClick={(event) => event.stopPropagation()}>
            {isDeleteButtonVisible && (
              <TableDeleteButtonComponent
                onClick={() =>
                  props.onSelectUserToDelete({
                    uuid: listingItem.uuid,
                    firstName: listingItem.firstName,
                    lastName: listingItem.lastName,
                  })
                }
                title={translations.dealerDeleteButtonTitle}
                idForTesting={`dealer-listing-table-item-${listingItem.uuid}-delete-button`}
              />
            )}
          </div>
        ),
      },
    };
  };

  const rows: DealerListingTableRow[] = props.listingItems.map((listingItem) =>
    createTableRow(listingItem)
  );

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isError={props.isError}
      isLoading={props.isLoading}
    />
  );
};

export default DealerListingTableComponent;
